var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpcoes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "4px",
    viewBox: "0 0 22 4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "opcoes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Home_Pesquisa",
    transform: "translate(-1309.000000, -5513.000000)",
    fill: "",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "item_stock_1-copy-14",
    transform: "translate(972.000000, 5013.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339,500 C340.104569,500 341,500.895431 341,502 C341,503.104569 340.104569,504 339,504 C337.895431,504 337,503.104569 337,502 C337,500.895431 337.895431,500 339,500 Z M348,500 C349.104569,500 350,500.895431 350,502 C350,503.104569 349.104569,504 348,504 C346.895431,504 346,503.104569 346,502 C346,500.895431 346.895431,500 348,500 Z M357,500 C358.104569,500 359,500.895431 359,502 C359,503.104569 358.104569,504 357,504 C355.895431,504 355,503.104569 355,502 C355,500.895431 355.895431,500 357,500 Z",
    id: "opcoes"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpcoes);
export default __webpack_public_path__ + "static/media/opcoes.3cf9706518120aceae56fbd3ee5d24f0.svg";
export { ForwardRef as ReactComponent };